import Diversity2Icon from '@mui/icons-material/Diversity2';
import SharesCommiteeList from './SharesCommiteeList';
import SharesCommiteeShow from './SharesCommiteeShow';

export default {
    list: SharesCommiteeList,
    icon: Diversity2Icon,
    show: SharesCommiteeShow,
}